import * as React from 'react';
import { useLocation } from '@reach/router';

/**
 * this simulates the behavior of gatsby's
 * `onRouteUpdate`
 * (https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#onRouteUpdate)
 *
 * but as a React hook, so we can use it in places
 * where we need data from static queries
 */

export default function useOnRouteUpdate(
    callback: (pathname: string) => void,
): void {
    const location = useLocation();

    React.useEffect(() => {
        callback(location?.pathname ?? '');
    }, [callback, location?.href, location?.pathname, location?.search]);
}
